export const SORTING_OPTIONS = [
  'salesQuantity.DESC',
  'name.ASC',
  'name.DESC',
  'price.ASC',
  'price.DESC',
  'createdAt.DESC',
  'createdAt.ASC',
  'ratingAverage.DESC',
  //'reviewsCount.DESC'
];

export const CIRCLEK_SORTING_OPTIONS = [
  'salesQuantity.DESC',
  'name.ASC',
  'name.DESC',
  'price.ASC',
  'price.DESC',
  'createdAt.DESC',
  'createdAt.ASC',
];
